// load all .sql files in the same directory and export a map of them by base name

const modules = import.meta.glob('./*.sql', { query: '?raw', import: 'default', eager: true })

const sqlFiles: Record<string, string> = {}

for (const path in modules) {
  const match = path.match(/^\.\/([^/]+)\.sql$/)
  if (match) {
    const name = match[1]
    sqlFiles[name] = modules[path] as string
  }
}

export default sqlFiles
